export default __webpack_public_path__ + "static/media/officerAndNeighbor.6bcc7006.jpg";